import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

const navLinks = [
  { to: '/', text: 'Home' },
  { to: '/services', text: 'Services' },
  { to: '/portfolio', text: 'Portfolio' },
  { to: '/pricing', text: 'Pricing' },
  { to: '/about', text: 'About' },
  { to: '/contact', text: 'Contact' },
];

const Navbar: React.FC = () => {
  const location = useLocation();
  const [isMobNavOpen, setMobNavOpen] = useState(false);

  const handleNavLink = () => setMobNavOpen(false);

  return (
    <nav className="nav-root premium-nav">
      <div className="nav-logo gradient-text">CodeNova AI</div>
      <div className="nav-desktop">
        <ul className="nav-links">
          {navLinks.map(link => (
            <li key={link.to}>
              <Link
                className={location.pathname === link.to ? 'nav-link active' : 'nav-link'}
                to={link.to}
              >
                {link.text}
              </Link>
            </li>
          ))}
        </ul>
      </div>
      <div className="mob-hamburger" onClick={() => setMobNavOpen(open => !open)}>
        <span className={`ham-bar${isMobNavOpen ? ' open' : ''}`}></span>
        <span className={`ham-bar${isMobNavOpen ? ' open' : ''}`}></span>
        <span className={`ham-bar${isMobNavOpen ? ' open' : ''}`}></span>
      </div>
      <div className={`mob-nav-drawer${isMobNavOpen ? ' open' : ''}`}>
        <ul className="mob-nav-links">
          {navLinks.map(link => (
            <li key={link.to}>
              <Link
                className={location.pathname === link.to ? 'nav-link active' : 'nav-link'}
                to={link.to}
                onClick={handleNavLink}
              >
                {link.text}
              </Link>
            </li>
          ))}
        </ul>
      </div>
      {isMobNavOpen && <div className="mob-nav-backdrop" onClick={() => setMobNavOpen(false)}></div>}
    </nav>
  );
};
export default Navbar;
